<div
  id="cc-banner"
  role="dialog"
  aria-live="polite"
  aria-label="Cookie consent"
  [class.cc-visible]="consentService.bannerVisible()" >


  <div class="cc-inner">
      <div class="cc-text">
          <strong>Vi bruger cookies</strong>
          Vi bruger nødvendige cookies for at få vores site til at fungere. Med dit
          samtykke vil vi også gerne sætte analyse- og markedsføringscookies for at
          forstå brugen af sitet og personalisere indhold. Du kan til enhver tid
          ændre dit valg. Læs <a (click)="navigateTo('/cookie-policy')">cookiepolitik</a> og
          <a (click)="navigateTo('/privacy-policy' )" >privatlivspolitik</a>.
      </div>
      <div class="cc-actions">
          <button type="button" class="cc-btn cc-btn-settings" (click)="openSettings()"> Administrer valg </button>
          <button type="button" class="cc-btn cc-btn-reject" (click)="consentService.rejectAll()"> Afvis alle </button>
          <button type="button" class="cc-btn cc-btn-accept" (click)="consentService.acceptAll()"> Accepter alle </button>
      </div>
  </div>
</div>

<div
  id="cc-modal-overlay"
  [class.cc-visible]="consentService.settingsOpen()"
  (click)="consentService.closeSettings()" >
  <div
    id="cc-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cc-modal-title"
    (click)="$event.stopPropagation()" >
    <h2 id="cc-modal-title">Administrer cookiepræferencer</h2>
    <p>
        Vælg hvilke kategorier af cookies du tillader. Du kan til enhver tid
        opdatere dette fra sitets bundtekst.
    </p>

    <div class="cc-category" *ngFor="let key of categoryKeys">
      <div class="cc-category-header">
        <label [attr.for]="'cc-cat-' + key">
          {{ categories[key].label }}
          <ng-container *ngIf="categories[key].required"> (Altid aktiv)</ng-container>
        </label>
        <label class="cc-switch" [attr.for]="'cc-cat-' + key">
          <input
            type="checkbox"
            [id]="'cc-cat-' + key"
            [checked]="draft[ key ]"
            [disabled]="categories[ key ].required"
            (change)="toggle( key )" />
          <span class="cc-switch-track"></span>
        </label>
      </div>
      <p>{{ categories[key].description }}</p>
    </div>

    <div class="cc-modal-actions">
      <button type="button" class="cc-btn cc-btn-reject" (click)="consentService.rejectAll()">Afvis alle</button>
      <button type="button" class="cc-btn cc-btn-accept" (click)="savePreferences()">Gem</button>
    </div>
  </div>
</div>
